import { useState } from 'react'

// Domains
import { ProductSizeGuide } from '../SizeGuide.types'

// Components
import SizeChart from '../../sizeChart'
import MeasuringGuide from '../../sizeChart/components/measuringGuide/MeasuringGuide'
import Tabs, { Tab } from '../../tabs'

// Styles
import RichTextDomain from '@src/quince-site-common/src/domains/RichText'
import { RichText as RichTextC } from '../../../molecules'
import styles from './SizeGuideTwo.module.scss'

interface SizeGuideTwoProps {
  wrapperClassName?: string
  productSizeGuides: ProductSizeGuide[]
  activeSizeGuideUnitIndex: number
}

const SizeGuideTwo = (props: SizeGuideTwoProps) => {
  const [activeTabIdx, setActiveTabIdx] = useState(
    `${props.productSizeGuides[0].sizeChart.title}${props.productSizeGuides[0].measuringGuide?.title}`,
  )
  return (
    <div className={props.wrapperClassName}>
      <Tabs
        activeTabId={activeTabIdx}
        onChange={activeIdx => {
          setActiveTabIdx(activeIdx)
        }}
        className={styles.sizeGuideTabsContainer}
        tabButtonWrapperClassname={styles.sizeGuideTabsContainer__tabButtonWrapper}
        activeTabHeaderClassName={styles.sizeGuideTabsContainer__tabHeader__active}
      >
        {props.productSizeGuides.map((psg: ProductSizeGuide) => {
          const measuringGuideTitle = psg.measuringGuide?.richTexts
            ? RichTextDomain.fromContentful(psg.measuringGuide.richTexts[0])
            : undefined
          const measuringGuideTitleRichTextProps = RichTextDomain.makeRichTextProps(measuringGuideTitle)
          const tabTitle =
            (measuringGuideTitleRichTextProps && <RichTextC {...measuringGuideTitleRichTextProps} />) || ''

          return (
            <Tab
              key={psg.sizeChart.title + (psg.measuringGuide?.title || '')}
              id={psg.sizeChart.title + (psg.measuringGuide?.title || '')}
              title={tabTitle}
              headerClassName={styles.sizeGuideTabsContainer__tabHeader}
              panelClassName={styles.sizeGuideTabsContainer__tabContent}
            >
              <div className={styles.sizeGuideTwo__measuringGuideWrapper}>
                {psg.measuringGuide && <MeasuringGuide measuringGuide={psg.measuringGuide} />}
              </div>

              <SizeChart productSizeGuides={[psg]} activeSizeGuideUnitIndex={props.activeSizeGuideUnitIndex} />
            </Tab>
          )
        })}
      </Tabs>
    </div>
  )
}

export default SizeGuideTwo
